module.exports = __webpack_public_path__ + "media/components/assets/img/logo/testimonials/facebook-6b791826eba7a0b98721734209140280.svg";